



























































































import { Build } from "models/Build";
import { Role } from "models/Rolle";
import Vue, { PropType } from "vue";
import _icons from "../../services/icons";

export default Vue.extend({
	name: "BuildChipComp",
	props: {
		close: Boolean,
		build: Object as PropType<Build>,
		small: Boolean,
		disabled: Boolean,
		star: Boolean,
		ownProfile: Boolean,
		edit: Boolean,
	},
	data: () => ({
		chip: true,
		stars: [0, 1, 2, 3],
		selectedRole: null as number,
	}),
	computed: {
		classIcon: function(): string {
			if (this.build && this.build.class) {
				return _icons.classIcon(this.build.class.abbr);
			}
			return "";
		},
		color: function(): string {
			if (this.build && this.build.class) {
				return this.build.class.color;
			}
			return "";
		},
		roles: function(): Role[] {
			if (this.build && this.build.role != null && this.build.role.length > 0) {
				return this.build.role;
			} else {
				return [{ id: 0 }] as Role[];
			}
		},
	},
	methods: {
		togglePrefer: function(stars: number): void {
			if (this.ownProfile) {
				this.$emit("togglePrefer", stars);
			}
		},
		closeChip: function(): void {
			this.chip = false;
			this.$emit("close");
		},
		prefered: function(star: number): string {
			let color = "";

			if (star === 0) {
				color = "black";
			} else if (star === 1) {
				color = "#cd7f32";
			} else if (star === 2) {
				color = "grey";
			} else if (star === 3) {
				color = "yellow darken-3";
			}

			return color;
		},
		icon: function(star: number): string {
			if (star > 0) {
				return "star";
			} else {
				return "star_outline";
			}
		},
		roleIcon: function(role: string): string {
			if (role != null && role != "" && role.trim() != "") {
				return _icons.roleIcon(role);
			}
			return "";
		},
		selectRole: function(index: number): void {
			if (this.edit) {
				if (this.selectedRole == null || this.selectedRole != index) {
					this.selectedRole = index;
				} else {
					this.selectedRole = null;
				}
				this.$emit("selected", this.selectedRole);
			}
		},
		selected: function(index: number): boolean {
			return this.selectedRole === index;
		},
		roleChange: function(change: string): void {
			this.$emit("roleChange", change);
		},
	},
});
